import { useMutation } from '@tanstack/react-query';
import { useBackoffice } from '../../backoffice/useBackoffice';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import { ExternalAccount } from './useExternalAccounts';

export const useCreateExternalAccount = () => {
  const { getAccessTokenSilently } = useAuth0();
  const { developerId } = useBackoffice();

  const mutation = useMutation({
    mutationKey: ['create-external-account'],
    mutationFn: async ({
      customerId,
      payload,
    }: {
      customerId: string;
      payload: Omit<ExternalAccount, 'id' | 'created_at'>;
    }) => {
      const token = await getAccessTokenSilently();
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_API_URL}/customers/${customerId}/external-accounts`,
        payload,
        {
          params: {
            consumerId: developerId,
          },
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return res.data?.data;
    },
  });

  return mutation;
};
